import React from "react";
import { makeStyles } from "@material-ui/core";

type Props = {
  children: React.ReactNode;
};

// there is a native implementation in mui 5
export const DividerWithText = ({ children }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.border} />
      <div className={classes.content}>{children}</div>
      <div className={classes.border} />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center"
  },
  border: {
    borderBottom: `2px solid ${theme.palette.text.primary}`,
    width: "100%"
  },
  content: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2)
  }
}));
